import { FlagsManager } from './contracts/flags-manager';
import { NoOpFlagsManager } from './managers/no-op-flags-manager';

/**
 * Initialize this with a default value.
 */
let flagsManager: FlagsManager = new NoOpFlagsManager();

/**
 * Swaps out the current FlagsManager for the given implementation.
 * This should be used sparingly as it is meant for high level bootstrapping.
 */
export function setFlagsManager(manager: FlagsManager) {
  flagsManager = manager;
}

export function getFlagsManager() {
  return flagsManager;
}
